module.exports = __webpack_public_path__ + "img/chart-line.2cf67ea3.svg";